import React, { useEffect, useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";

import { cidadesDoEstado } from "services/bidFreteApi";
import SeletorConvidados from "../convite/SeletorConvidados";

// Passo 4 do NovoBidWizard, só no RFP (H2 PO1-2841 + H7 PO1-2847): cabeçalho
// da planilha modelo (Tpl*: cidade de origem, modal, negócio, serviço, tipo de
// serviço e unidade de frete, os mesmos campos de "salvar tabela" em
// NovaTabelaFrete), o prazo das propostas e as convidadas.
//
// As candidatas vêm de GET /gobid/bids/:id/candidatos-convite, que precisa do
// BID gravado: o wizard salva o rascunho ao entrar neste passo (`bidId`). As
// escolhidas vão por POST /participantes ao salvar; o e-mail só sai quando o
// BID é publicado na aba Convites (depois do pacote).

export default function StepPropostaConvidados({ form, onChange, listas, erros, empresaId, bidId, onConvidados }) {
  const [cidades, setCidades] = useState([]);
  const [ufOrigem, setUfOrigem] = useState(form.tplUfOrigem || "");

  useEffect(() => {
    if (!ufOrigem) {
      setCidades([]);
      return undefined;
    }
    const estado = (listas.estados || []).find((e) => (e.uf || e.sigla) === ufOrigem);
    if (!estado || !estado.id) return undefined;
    let ativo = true;
    cidadesDoEstado(estado.id)
      .then((lista) => {
        if (ativo) setCidades(lista);
      })
      .catch(() => {
        if (ativo) setCidades([]);
      });
    return () => {
      ativo = false;
    };
  }, [ufOrigem, listas.estados]);

  const campo = (nome) => (e) => {
    const v = e.target.value;
    onChange({ [nome]: v });
  };

  return (
    <>
      <div className="lf-section">
        <div className="lf-section-title">Cabeçalho da planilha modelo (proposta)</div>
        <div className="lf-muted" style={{ marginBottom: 10 }}>
          A transportadora responde só na planilha modelo gerada pelo BID; a proposta vira uma tabela do tipo Avaliação, inativa, com este cabeçalho.
        </div>
        <div className="bf-grid-2">
          <FormGroup>
            <Label>UF de origem</Label>
            <Input
              type="select"
              value={ufOrigem}
              onChange={(e) => {
                const v = e.target.value;
                setUfOrigem(v);
                onChange({ tplUfOrigem: v, tplIdCidadeOrigem: "" });
              }}
            >
              <option value="">—</option>
              {(listas.estados || []).map((x) => (
                <option key={x.id || x.uf} value={x.uf || x.sigla}>
                  {x.uf || x.sigla} - {x.nome}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Cidade de origem</Label>
            <Input type="select" value={form.tplIdCidadeOrigem || ""} onChange={campo("tplIdCidadeOrigem")} disabled={!ufOrigem}>
              <option value="">—</option>
              {cidades.map((c) => (
                <option key={c.id || c.Id} value={c.id || c.Id}>
                  {c.nome || c.Nome}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Modal *</Label>
            <Input type="select" value={form.tplIdModal || ""} onChange={campo("tplIdModal")}>
              <option value="">—</option>
              {(listas.modais || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </Input>
            {erros.tplIdModal ? <div className="lf-erro-campo">{erros.tplIdModal}</div> : null}
          </FormGroup>
          <FormGroup>
            <Label>Unidade de frete *</Label>
            <Input type="select" value={form.tplIdFreteUnidade || ""} onChange={campo("tplIdFreteUnidade")}>
              <option value="">—</option>
              {(listas.unidades || []).map((u) => (
                <option key={u.id} value={u.id}>
                  {u.codigo ? `${u.codigo} — ` : ""}
                  {u.nome}
                </option>
              ))}
            </Input>
            {erros.tplIdFreteUnidade ? <div className="lf-erro-campo">{erros.tplIdFreteUnidade}</div> : null}
          </FormGroup>
          <FormGroup>
            <Label>Negócio</Label>
            <Input type="select" value={form.tplIdNegocio || ""} onChange={campo("tplIdNegocio")}>
              <option value="">—</option>
              {(listas.negocios || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.descricao || x.nome}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Tipo de serviço</Label>
            <Input type="select" value={form.tplIdTipoServico || ""} onChange={campo("tplIdTipoServico")}>
              <option value="">—</option>
              {(listas.servicos || []).map((x) => (
                <option key={x.id || x.nome} value={x.id || x.nome}>
                  {x.nome}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Serviço (texto)</Label>
            <Input type="text" maxLength={50} value={form.tplServico || ""} onChange={campo("tplServico")} placeholder="Ex.: Fracionado" />
          </FormGroup>
          <FormGroup>
            <Label>Prazo para as propostas *</Label>
            <Input type="date" value={form.prazoPropostas || ""} onChange={campo("prazoPropostas")} />
            {erros.prazoPropostas ? <div className="lf-erro-campo">{erros.prazoPropostas}</div> : <div className="lf-muted">As convidadas enviam a planilha pelo MeuFrete até esta data.</div>}
          </FormGroup>
        </div>
      </div>

      <div className="lf-section">
        {bidId ? (
          <SeletorConvidados empresaId={empresaId} bidId={bidId} onChange={onConvidados} />
        ) : (
          <div className="bf-placeholder">Salvando o rascunho para listar as transportadoras...</div>
        )}
        {erros.convidados ? <div className="lf-aviso lf-aviso-danger">{erros.convidados}</div> : null}
        <div className="lf-muted">As convidadas recebem o e-mail quando você publicar o BID na aba Convites, depois que o pacote estiver pronto. Dá para incluir mais lá.</div>
      </div>
    </>
  );
}
